import Axios from "axios";

import { convertSatangToBahtAndRoundTwoDecimal } from "../../lib/formatter";
import { Labels } from "./label";

function convertProductPriceForForm(price) {
  if (price === null || price === undefined) return null;

  return convertSatangToBahtAndRoundTwoDecimal(price);
}

export function normalizeServiceProductSearchResult(item) {
  return {
    id: item.id,
    name: item.name,
    code: item.product_code,
    stock: item.quantity,
    status: item.status,
    cost: convertProductPriceForForm(item.cost_price),
    promotion_price: convertProductPriceForForm(item.promotion_price),
    promotion_started_at: item.promotion_started_at,
    promotion_ended_at: item.promotion_ended_at,
    display: `${item.name} (${item.product_code})`,
  };
}

export class Subscriptions {
  // Set subscriptions url
  constructor(apiUrl, headers) {
    this.subscribersUrl = `${apiUrl}/subscriptions`;
    this.headers = headers;

    // Label
    this.label = new Labels(this.subscribersUrl, headers);
  }

  async getRecurringNotifyReport() {
    const url = `${this.subscribersUrl}/report/recurring-notify`;
    const blobHeaders = {
      ...this.headers,
      Accept: "application/octet-stream",
    };

    const response = await Axios.get(url, {
      headers: blobHeaders,
      responseType: "blob",
    });

    return response;
  }

  async searchProducts(textSearch) {
    const url = `${this.subscribersUrl}/products/search`;

    try {
      const response = await Axios.get(url, {
        headers: this.headers,
        params: { textSearch },
      });

      return response;
    } catch (error) {
      console.error("Failed to search products:", error);
      throw error;
    }
  }

  async searchServiceProducts(textSearch) {
    if (!textSearch || textSearch.length < 2) {
      return [];
    }

    try {
      const response = await this.searchProducts(textSearch);
      const products = response.data.result || [];

      return products
        .filter(
          (item) =>
            item.name &&
            item.name.trim() &&
            item.product_code &&
            item.product_code.trim()
        )
        .map(normalizeServiceProductSearchResult);
    } catch (error) {
      console.error("Failed to search service products:", error);

      return [];
    }
  }

  async getPackageById(id, language) {
    const url = `${this.subscribersUrl}/packages/${id}`;
    const headers = language
      ? { ...this.headers, "x-accept-language": language }
      : this.headers;

    const response = await Axios.get(url, { headers });

    return response;
  }

  async createPackage(params) {
    const url = `${this.subscribersUrl}/packages`;

    const response = await Axios.post(url, params, { headers: this.headers });

    return response;
  }

  async updatePackage(id, params, language) {
    const url = `${this.subscribersUrl}/packages/${id}`;
    const headers = language
      ? { ...this.headers, "x-accept-language": language }
      : this.headers;

    const response = await Axios.put(url, params, { headers });

    return response;
  }
}
